import { createGalleryLayout } from "./components/_layout";

const page = createGalleryLayout("okulda-yasam", "Okulda Yaşam", 1, true);

export default page;